<template>
  <section class="views">
    <!-- header -->
    <headers select="6"></headers>
    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="require('@/assets/image/hodgepodge/pcbanner.jpg')"
      />
    </div>

    <!-- 活动回顾内容 -->
    <div class="event-review">
      <div class="event-container">
        <div v-for="item in events" :key="item.id" class="event-item">
          <!-- 左側時間軸節點 -->
          <div class="event-timeline">
            <div class="event-date">
              <div class="year">{{ item.year }}</div>
              <div class="day">{{ item.date }}</div>
            </div>
            <div class="event-dot-wrapper">
              <span class="event-dot"></span>
            </div>
          </div>

          <!-- 右側卡片 -->
          <div style="margin-bottom: 24px">
            <div
              class="event-card"
              v-for="(card, index) in item.list"
              :key="index"
            >
              <div
                class="event-card-main"
                @click="openResult(card.resultUrl)"
                @keyup.enter="openResult(card.resultUrl)"
                role="button"
                tabindex="0"
              >
                <div class="event-card-left">
                  <h3 class="event-title">{{ card.title }}</h3>
                  <!-- <a
                    class="event-result-link"
                    :href="card.resultUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span
                      style="
                        display: inline-flex;
                        align-items: center;
                        gap: 5px;
                      "
                    >
                      比賽結果
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 16 16"
                        fill="none"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M2 8h12"
                          stroke="#ff782f"
                          stroke-width="1.8"
                          stroke-linecap="round"
                        />
                        <path
                          d="M10 4l4 4-4 4"
                          stroke="#ff782f"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </a> -->
                </div>
                <div class="event-card-right">
                  <img
                    class="event-image"
                    :src="card.image"
                    :alt="card.title"
                  />
                </div>
              </div>

              <div
                class="event-card-footer"
                v-if="card.media && card.media.length"
              >
                <div class="media-label">報道媒體：</div>
                <div class="media-list">
                  <div
                    v-for="(mediaItem, index) in card.media"
                    :key="mediaItem.name + index"
                    class="media-item"
                  >
                    <a
                      class="media-link"
                      :href="mediaItem.url"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ mediaItem.name }}
                    </a>
                    <span
                      v-if="index < card.media.length - 1"
                      class="media-separator"
                    >
                      <!-- / -->
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
import eventReviewList from "@/config/eventReview";

export default {
  name: "eventReview",
  data() {
    return {
      events: eventReviewList,
    };
  },
  components: {
    headers,
  },
  methods: {
    openResult(url) {
      if (!url) return;
      window.open(url, "_blank");

    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #ff782f;
}

.posters {
  width: 100%;
  display: flex;
  position: relative;
  img {
    width: 100%;
  }
}

.event-review {
  width: 100%;
  padding: 60px 0 60px;

  .event-container {
    max-width: 1160px;
    margin: 0 auto;
  }

  .event-item {
    display: flex;
    align-items: stretch;
    position: relative;
  }

  .event-timeline {
    display: flex;
    position: relative;
    // margin-top: 20px;
  }

  .event-timeline::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 18px;
    width: 1px;
    background: #ffffff;
  }
  .event-date {
    text-align: left;
    margin-right: 40px;

    .year {
      font-size: 36px;
      font-weight: 700;
      color: #fff;
      // line-height: 1.3;
      font-family: DIN Black, DIN Black;
    }

    .day {
      margin-top: 6px;
      font-size: 24px;
      color: #fff;
      // line-height: 1.3;
      font-family: PingFang SC, PingFang SC;
    }
  }

  .event-dot-wrapper {
    position: relative;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-left: auto;

    &::before {
      content: "";
      position: absolute;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: rgba(255, 120, 47, 0.15);
    }
  }

  .event-dot {
    position: relative;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      rgba(254, 228, 127, 1) 0%,
      rgba(254, 228, 127, 1) 30%,
      rgba(254, 228, 127, 0.61) 50%,
      rgba(254, 228, 127, 0.31) 70%,
      rgba(254, 228, 127, 0.19) 100%
    );
    z-index: 9;
  }

  .event-item:first-child .event-timeline::after {
    top: calc(0% + 36px);
  }

  .event-item:last-child .event-timeline::after {
    bottom: calc(100%);
  }

  .event-card {
    flex: 1;
    border-radius: 24px;
    border: 2px solid #ffd900;
    background-color: #ffffff;
    padding: 20px 20px 16px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    margin-left: 60px;
    width: 952px;
    text-align: left;
  }
  .event-item:last-child .event-card {
    margin-bottom: 0;
  }

  .event-card-main {
    display: flex;
    align-items: stretch;
    column-gap: 24px;
    cursor: pointer;
    &:hover .event-title {
      color: #ff782f;
    }
    &:hover .event-image {
      transform: scale(1.05);
      filter: brightness(1.05);
    }
  }

  .event-card-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .event-title {
    line-height: 1.5;
    margin: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 28px;
    color: #424141;
  }

  .event-result-link {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #ff782f;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 20px;

    &:hover {
      opacity: 0.9;
    }
  }

  .event-card-right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .event-image {
    width: 280px;
    height: 155px;
    border-radius: 12px;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease, filter 0.3s ease;
  }

  .event-card-footer {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #f2f2f2;
    font-size: 13px;
    color: #333333;
    line-height: 1.6;
    display: flex;
  }

  .media-label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    margin-right: 4px;
    white-space: nowrap;
  }
  .media-list {
    display: flex;
    flex-wrap: wrap;
  }
  .media-item {
    margin-right: 20px;
  }
  .media-link {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: #ff782f;
    }
  }

  .media-separator {
    margin: 0 4px;
    color: #cccccc;
  }

  @media (max-width: 992px) {
    .event-container {
      padding: 20px 16px 24px;
    }

    .event-item {
      flex-direction: column;
    }

    .event-timeline {
      flex: 0 0 auto;
      margin-bottom: 12px;
    }

    .event-date {
      text-align: left;
      margin-right: 0;
      margin-left: 8px;
    }

    .event-card-main {
      flex-direction: column;
      row-gap: 16px;
      cursor: pointer;
    }

    .event-card-right {
      justify-content: flex-start;
    }

    .event-image {
      width: 100%;
      height: auto;
      max-width: 280px;
    }
  }
}
</style>
